import _ from 'lodash';
import TermDef from './VocabularyListTermObject';

export default class PredefVocabulary {
  constructor({ vocabularyName, terms = [], vocabularyType = 'terms' }) {
    this.vocabularyName = vocabularyName;
    this.vocabularyType = vocabularyType;
    this.terms = terms;
  }

  get terms() {
    return this._terms;
  }

  set terms(value) {
    try {
      if (!Array.isArray(value)) {
        this._terms = [];
        console.log('bad terms:', value);
      } else {
        this._terms = _(value).map((term) => {
          if (!(term instanceof TermDef)) return new TermDef(term);
          return term;
        }).uniq('vocabularyName')
          .value();
      }
    } catch (err) {
      console.log('set terms error', err);
    }
  }

  toJSON() {
    return {
      vocabularyType: this.vocabularyType,
      terms: this.terms.map(term => term.toJSON()),
      vocabularyName: this.vocabularyName,
    };
  }

  toCSV() {
    return this.terms.map(t => t.toCSV())
      .join('\n');
  }
}
